import { render, staticRenderFns } from "./CameraPanel.vue?vue&type=template&id=80404676&scoped=true"
import script from "./CameraPanel.vue?vue&type=script&lang=js"
export * from "./CameraPanel.vue?vue&type=script&lang=js"
import style0 from "./CameraPanel.vue?vue&type=style&index=0&id=80404676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80404676",
  null
  
)

export default component.exports